<div class="range-content">
  <input class="range" (input)="emitValue($event)" [ngClass]="[themeStyle]" style="--icon: url({{icon}});" value="0" type="range" [min]="min" [max]="max" (change)="acceptTermsAndConditions($event)">
  <label class="text">{{label}}</label>
</div>